<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">
    <div class="modal-background"
      @click="$emit('input', false)">
    </div>
    <div class="modal-content">
      <div class="modal-card">
        <header 
          v-if="title"
          class="modal-card-head">
          <p class="modal-card-title">{{ title }}</p>
        </header>
        <div class="modal-card-body">
          <component
            :is="tag"
            v-if="value"
            :value="date"
            inline
            @input="changeDate($event)">
          </component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VDatepicker from '@/components/base/VDatepicker'
import VDatetimepicker from '@/components/base/VDatetimepicker'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    date: {
      type: Date
    },
    title: {
      type: [String, Number]
    },
    tag: {
      type: String,
      default: 'VDatepicker'
    }
  },
  components: { VDatepicker, VDatetimepicker },
  methods: {
    changeDate(v) {
      this.$emit("update:date", v);
      this.$emit("change", v);
      this.close();
    },
    close() {
      this.$emit('input', false);
    }
  }
}
</script>

<style scoped>
.modal-card {
  border-radius: 6px;
  width: 343px;
}

.modal-card-head {
  width: 343px;
}

.modal-card-body {
  padding: 0;
  width: 343px;
  height: 385px;
}
</style>
